// Test IDs for the admin dashboard (user management + all meeting records).

export const ADMIN = {
	container: 'admin-dashboard-container',
	tabUsers: 'admin-tab-users',
	tabMeetings: 'admin-tab-meetings',
	tabTrtc: 'admin-tab-trtc',
	createUserBtn: 'admin-create-user-btn',
	newUsernameInput: 'admin-new-username-input',
	newNameInput: 'admin-new-name-input',
	newPasswordInput: 'admin-new-password-input',
	newEmailInput: 'admin-new-email-input',
	newUserSubmitBtn: 'admin-new-user-submit-btn',
	userRow: (id) => `admin-user-row-${id}`,
	userEmail: (id) => `admin-user-email-${id}`,
	editEmailBtn: (id) => `admin-edit-email-btn-${id}`,
	deleteUserBtn: (id) => `admin-delete-user-btn-${id}`,
	resetPasswordBtn: (id) => `admin-reset-password-btn-${id}`,
	trtcContainer: 'admin-trtc-settings-container',
	trtcSdkAppId: 'admin-trtc-sdk-app-id',
	trtcSecretMasked: 'admin-trtc-secret-masked',
	trtcStatusBadge: 'admin-trtc-status-badge',
	trtcConsoleLink: 'admin-trtc-console-link',
};

export const MEETINGS = {
	container: 'meetings-list-container',
	row: (id) => `meeting-row-${id}`,
	deleteBtn: (id) => `meeting-delete-btn-${id}`,
	exportBtn: (id) => `meeting-export-btn-${id}`,
	summaryToggle: (id) => `meeting-summary-toggle-${id}`,
	evaluationItem: (id, idx) => `meeting-eval-item-${id}-${idx}`,
	emptyState: 'meetings-empty-state',
};
